import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';

import {
  WizardPosition,
  WizardStep,
} from '@app/shared/components/wizard/wizard.model';

@Component({
    selector: 'dgx-wizard-title',
    templateUrl: './wizard-title.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WizardTitleComponent implements OnChanges {
  @Input() public currentStep: WizardStep;
  @Input() public customLabel: string;

  public title: string;

  public ngOnChanges(): void {
    const { label, position } = this.currentStep;
    const prefix = this.getPrefix(position);
    this.title = this.buildTitle(prefix, label, this.customLabel);
  }

  private getPrefix(position: WizardPosition): string {
    const { step, task } = position;
    const isTask = task && task !== -1;
    let prefix = `${step}.`;
    return (prefix += isTask ? `${task}. ` : ` `);
  }

  private buildTitle(
    prefix: string,
    label: string,
    customLabel?: string
  ): string {
    return (prefix += customLabel || label);
  }
}
